(function () {
  function findVariantId(productData, selectedOptions) {
    if (!productData || !productData.variants) return null;
    const target = productData.variants.find(function (v) {
      return v.options.every(function (optVal, idx) {
        return optVal == selectedOptions[idx];
      });
    });
    return target ? target.id : null;
  }

  function onVariantChange(wrapper) {
    const productJsonEl = wrapper.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    const data = JSON.parse(productJsonEl.textContent);
    const selects = Array.from(wrapper.querySelectorAll('.marker-variant-select'));
    const selected = selects.map(function (s) { return s.value; });
    const id = findVariantId(data, selected);
    const idInput = wrapper.querySelector('input[name="id"]');
    if (id && idInput) idInput.value = id;
  }

  function setSelectsToVariant(wrapper, variant) {
    if (!variant) return;
    var selects = Array.from(wrapper.querySelectorAll('.marker-variant-select'));
    if (!selects.length) return;
    var optionsForVariant = variant.options;
    selects.forEach(function (sel, idx) {
      var wanted = optionsForVariant[idx];
      if (!wanted) return;
      Array.from(sel.options).forEach(function (opt) {
        if (opt.value == wanted) opt.selected = true;
      });
    });
  }

  function updateCartUI(variantId) {
  var drawerEl = document.querySelector('cart-drawer');
  var sections = ['cart-drawer', 'cart-icon-bubble'];
  var url = '/?sections=' + sections.join(',');

  return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(res){ return res.ok ? res.json() : null; })
    .then(function(payload){
      if (!payload) return;

      if (drawerEl && typeof drawerEl.renderContents === 'function') {
        drawerEl.renderContents({ id: variantId, sections: payload });
      } else {
        sections.forEach(function(key){
          var html = payload[key];
          if (!html) return;
          var host = document.querySelector('[data-section-id="' + key + '"]')
                 || document.getElementById(key)
                 || document.querySelector('.shopify-section-' + key);
          if (!host) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section') || doc.body;
          host.innerHTML = inner.innerHTML;
        });
      }

      var bubble = document.querySelector('#cart-icon-bubble');
      if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open(bubble);

      return true;
    });
}

  function initProductMarkers(section) {
    if (!section || !section.classList.contains('product-markers-section')) return;

    const allMarkers = section.querySelectorAll('.product-markers__item');
    const mobileContainer = section.querySelector('.product-markers-for-mobile');
    const allMobileCards = mobileContainer ? mobileContainer.querySelectorAll('.product-markers__item-inner') : [];

    const renameColorSwatchInputIds = () => {
      section.querySelectorAll('.product-markers__item-inner').forEach((el, index) => {
        const allSwatchInputs = el.querySelectorAll("input[type='radio']");
        const allSwatchLabels = el.querySelectorAll('label.color-swatch');
        allSwatchInputs.forEach((input) => {
          const oldId = input.id;
          const oldName = input.name;
          input.id = `${oldId}-card${index}`;
          input.name = `${oldName}-card${index}`;
        });
        allSwatchLabels.forEach((label) => {
          const oldFor = label.htmlFor;
          label.htmlFor = `${oldFor}-card${index}`;
        });
      });
    };
    renameColorSwatchInputIds();

    const calcNewCoord = (marker) => {
      const card = marker.querySelector('.product-markers__item-inner');
      const markerRect = marker.getBoundingClientRect();
      if (!card) return;
      card.style.removeProperty('left');
      card.style.removeProperty('right');
      const cardRect = card.getBoundingClientRect();
      const screenWidth = document.documentElement.clientWidth || window.innerWidth;
      if (cardRect.right > screenWidth) {
        let newRight = markerRect.right - cardRect.right;
        if (card.classList.contains('product-markers__item-inner--to-right')) {
          newRight = -1 * (screenWidth - markerRect.right - 20);
        }
        card.style.left = 'auto';
        card.style.right = `${newRight}px`;
      } else if (cardRect.left < 0) {
        let newLeft = markerRect.left - cardRect.left;
        if (card.classList.contains('product-markers__item-inner--to-left')) {
          newLeft = -1 * markerRect.left;
        }
        card.style.right = 'auto';
        card.style.left = `${newLeft}px`;
      }
    };

    const onSelectMarker = (marker) => {
      const index = marker.dataset.index;
      const screenWidth = document.documentElement.clientWidth || window.innerWidth;

      allMarkers.forEach((m) => { m.classList.remove('mobile-initial-active'); });

      if (screenWidth >= 990) return;

      if (marker.classList.contains('active')) {
        if (screenWidth < 990) return;
        marker.classList.remove('active');
        return;
      }

      allMarkers.forEach((m) => { m.classList.remove('active'); });
      marker.classList.add('active');

      allMobileCards.forEach((card) => {
        card.classList.remove('active');
        if (card.dataset.index == index) card.classList.add('active');
      });

      if (screenWidth >= 990) calcNewCoord(marker);
    };

    allMarkers.forEach((marker) => {
      calcNewCoord(marker);
      marker.addEventListener('click', (event) => {
        if (event.target.closest('.js-color-swatches')) return;
        onSelectMarker(marker);
      });
      marker.addEventListener('mouseover', () => {
        if (marker.classList.contains('active')) return;
        const screenWidth = document.documentElement.clientWidth || window.innerWidth;
        if (screenWidth >= 990) calcNewCoord(marker);
      });
      marker.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') onSelectMarker(marker);
      });
    });

    document.addEventListener('click', (event) => {
      const screenWidth = document.documentElement.clientWidth || window.innerWidth;
      if (screenWidth < 990) return;
      const parentClicked = event.target.closest('.product-markers__item');
      allMarkers.forEach((marker) => {
        if (parentClicked != marker && !event.target.closest('.js-color-swatches')) {
          marker.classList.remove('active');
        }
      });
    });

    section.querySelectorAll('.marker-product-form').forEach(function (wrapper) {
      const picker = wrapper.querySelector('[data-variant-picker]');
      const overrideId = wrapper.getAttribute('data-variant-override');

      if (overrideId) {
        try {
          const productJsonEl = wrapper.querySelector('[data-product-json]');
          const data = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
          if (data && Array.isArray(data.variants)) {
            const v = data.variants.find(function (x) { return String(x.id) == String(overrideId); });
            if (v) setSelectsToVariant(wrapper, v);
          }
        } catch (e) {}
      }

      if (picker) {
        picker.addEventListener('change', function () { onVariantChange(wrapper); });
      }
      onVariantChange(wrapper);

      const form = wrapper.querySelector('.marker-atc-form');
      const button = wrapper.querySelector('[data-atc-button]');
      if (!form || !button) return;

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        const idInput = wrapper.querySelector('input[name="id"]');
        const qtyInput = wrapper.querySelector('input[name="quantity"]');
        console.debug('Submitting add', { id: idInput && idInput.value, qty: qtyInput && qtyInput.value });

        if (!idInput || !idInput.value) {
          console.warn('No variant id found on submit. Aborting.');
          return;
        }

        button.disabled = true;
        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
          .then(function (resp) {
            if (!resp.ok) {
              return resp.text().then(function (t) { throw new Error(t || 'Add failed'); });
            }
            return resp.json();
          })
          .then(function (data) {
            console.debug('Added to cart', data);
            button.disabled = false;
            button.classList.add('is-added');
            updateCartUI(data.id);
            setTimeout(function () { button.classList.remove('is-added'); }, 1200);
          })
          .finally(function () {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            button.removeAttribute('aria-busy');
            button.classList.remove('disabled');
          });
      });
    });
  }

  function initAnimations(section) {
    if (!section || !section.classList.contains('product-markers-section') || !section.querySelector('.animate-on-scroll')) return;
    const sectionContainer = section.querySelector('.product-markers');
    const imageContainer = section.querySelector('.product-markers__image-container');
    if (!sectionContainer || !imageContainer) return;
    if (window.ScrollTrigger && typeof window.ScrollTrigger.create === 'function') {
      window.ScrollTrigger.create({
        trigger: imageContainer,
        start: '50% bottom',
        end: 'bottom top',
        onEnter: () => sectionContainer.classList.add('animated')
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-markers-section').forEach(function (section) {
      initProductMarkers(section);
      initAnimations(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductMarkers(event.target);
    initAnimations(event.target);
  });

  form.addEventListener('submit', function (evt) {
  evt.preventDefault();
  button.disabled = true;

  const formData = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
    .then(function (resp) {
      if (!resp.ok) return resp.text().then(function (t) { throw new Error(t || 'Add failed'); });
      return resp.json();
    })
    .then(function (data) {
      console.debug('Added to cart', data);
      button.classList.add('is-added');
      updateCartUI(data.id);
      setTimeout(function(){ button.classList.remove('is-added'); }, 1200);
    })
    .catch(function (err) {
      console.error('Add to cart error', err);
    })
    .finally(function () {
      button.disabled = false;
    });
});
})();